module.exports = __webpack_public_path__ + "static/media/Defects.6e6ac49e.svg";